/* eslint-disable */
import api from '@/services/api';

export default {
  async fetchEstoque({ commit, dispatch }, payload) {
    const keys = Object.keys(payload);
    const params = new URLSearchParams();
    /* eslint-disable */
    for (const key of keys) {
      if (payload[key]) {
        params.append(key, payload[key]);
      }
    }
    dispatch('toggleLoading', true, { root: true });
    return api.get('/estoque', { params })
      .then(response => response.data)
      .then(data => {
        commit('SET_ESTOQUE', data.registros.data);
        commit('paginacao/SET_PAGINADOR', data.registros, { root: true });
        dispatch('toggleLoading', false, { root: true });
      });
  },

  async fetchDetalhesLote(context, numeroLote) {
    return api.get(`/estoque/lote/${numeroLote}`)
      .then(response => response.data);
  },

  async salvarEstoqueMinimo({ dispatch }, payload) {
    if (payload._id) {
      delete payload.updatedAt;
      delete payload.createdAt;
    }
    return await api.post('/estoque/notificacao/estoqueMinimo/', {
      ...payload,
    });

  },

  async filtrar({ commit }, payload) {
    commit('SET_FILTROS', payload);
  },

  async prepararExcelEstoque(_, payload) {
    const keys = Object.keys(payload);
    const params = new URLSearchParams();

    for (const key of keys) {
      if (payload[key]) {
        params.append(key, payload[key]);
      }
    }

    const { data } = await api.get('/estoque/excel', { params });

    if (!data) return null;

    const excelFormatado = data.map((infoDist) => ({
        lote: infoDist.lote,
        codigoProduto: infoDist.codigoProduto,
        descricaoProduto: infoDist.descricaoProduto,
        valorUnitario: infoDist.valorUnitario,
        quantidadeAtual: infoDist.quantidadeAtual,
        depositante: infoDist.depositante,
        grupo: infoDist.grupo,
        tipoUnidade: infoDist.tipoUnidade,
        situacao: infoDist.situacao,
    }));

    return excelFormatado;
  },
  /**
   * 
   * As empresas que existem no Zion, sistema que o pessoal da Armazenagem utiliza, é diferente do Conexos. Pois nem todas que existem no Conexos existem no Zion 
   *  
   */
  async fetchEmpresasFromArmazenagem({ commit }, payload) {
   try {
     const { data } = await api.get('/estoque/empresas-com-estoque-disponiveis');
     commit('SET_EMPRESAS_ARMAZENAGEM', data);
   } catch (error) {
    Vue.$toast.error(Vuetify.framework.lang.t('$vuetify.erroFetchEmpresasArmazenagem'));
   }
  }
}
